export const DeclarationContainerName = 'DeclarationContainerComponent';
